import { Component, OnInit } from '@angular/core';
import { SegovPage } from 'src/app/app.routes';
import { LinkClickable, SegovSigepoHeaderSectionComponent } from 'src/app/controls/segov-sigepo-header-section/segov-sigepo-header-section.component';
import { SegovSigepoPortalBodyComponent } from 'src/app/controls/segov-sigepo-portal-body/segov-sigepo-portal-body.component';
import { ControlsModule } from 'segov-sigepo-lib';
import { GratuidadeDePublicacaoComponent } from './sub-views/gratuidade-de-publicacao/gratuidade-de-publicacao.component';
import { PublicacaoDeMateriaComponent } from './sub-views/publicacao-de-materia/publicacao-de-materia.component';
import { RessarcimentoDeValoresComponent } from './sub-views/ressarcimento-de-valores/ressarcimento-de-valores.component';
import { TitulosServicos } from 'src/app/utils/common.collections';
import { ActivatedRoute, Router } from '@angular/router';
import { ListarTopicosServicoComponent } from './sub-views/listar-topicos-servico/listar-topicos-servico.component';
import { ConsultaComponent } from './sub-views/consulta/consulta.component';
import { EServico } from 'src/app/domain/enums/servico.enum';
import { MenuItem } from 'segov-sigepo-ui-component/projects/segov-sigepo-component/src/lib/controls/segov-sigepo-side-menu-with-body/segov-sigepo-side-menu-with-body.component';
import { MenuLateralComponent } from './sub-views/menu-lateral/menu-lateral.component';

@Component({
  selector: 'app-servicos-page',
  standalone: true,
  imports: [
    // Paginas com puro conteúdo UI
    PublicacaoDeMateriaComponent,
    ConsultaComponent,
    RessarcimentoDeValoresComponent,
    GratuidadeDePublicacaoComponent,

    // Integração com backend
    ListarTopicosServicoComponent,

    SegovSigepoHeaderSectionComponent,
    SegovSigepoPortalBodyComponent,
    MenuLateralComponent,
    ControlsModule
  ],
  templateUrl: './servicos-page.component.html',
  styleUrl: './servicos-page.component.css'
})
export class ServicosPageComponent implements OnInit {

  public title = "Serviços que o jornal disponibiliza para você!"
  public tituloPagina? : string;
  public ItemsMenuPerguntasFrequentes: MenuItem[] | undefined = undefined;
  public servicosMenu = TitulosServicos.map(x => x.servico);
  public menuSelecionado?: string;
  public verTodos = false;

  public RouteStack: LinkClickable[] = [
    { title: "Início", route: SegovPage.Inicio },
    { title: "Serviços", route: SegovPage.Servicos }
  ]

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router
  ) {}

  goToCalendario(){
    this.router.navigate([SegovPage.CalendarioPublicacao]);
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(
      params => {
        if(params['dados']){
          this.menuSelecionado = params['dados'];
          this.obterMenuSelecionado(this.menuSelecionado??'');
        } else {
          this.atualizaTitulo();
        }
      }
    );
  }

  public obterMenuSelecionado($event: string) {
    this.menuSelecionado = $event;
    this.atualizaTitulo();
    return $event;
  }

  public toggleVerTodos(){
    this.verTodos = !this.verTodos;
  }

  private atualizaTitulo(){
    if(!this.menuSelecionado) this.menuSelecionado = TitulosServicos[EServico.publicacaoMateria].servico;
    this.tituloPagina = TitulosServicos.find(x => x.servico == this.menuSelecionado)?.titulo ?? TitulosServicos[EServico.publicacaoMateria].titulo;
  }
}
